import FeedPage from "./FeedPage";

const Home = () => {
  return (
    <div className="w-full min-h-full">
      <FeedPage />
    </div>
  );
};

export default Home;